import { render, staticRenderFns } from "./MonthChargeHandler.vue?vue&type=template&id=2ca9e27c&scoped=true"
import script from "./MonthChargeHandler.vue?vue&type=script&lang=js"
export * from "./MonthChargeHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca9e27c",
  null
  
)

export default component.exports